import { render, staticRenderFns } from "./QnaManage.vue?vue&type=template&id=1bf3aaa9&"
import script from "./QnaManage.vue?vue&type=script&lang=js&"
export * from "./QnaManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports